import { render, staticRenderFns } from "./DiagnosticoCard.vue?vue&type=template&id=f0a332d0&"
import script from "./DiagnosticoCard.vue?vue&type=script&lang=ts&"
export * from "./DiagnosticoCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports